
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[category]/page/[page_number]",
      function () {
        return require("private-next-pages/[category]/page/[page_number].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[category]/page/[page_number]"])
      });
    }
  